<template>
  <d-container fluid class="main-content-container px-4">
    <dashboard v-if="!userIsCustomer" />
    <welcome v-if="userIsCustomer" />
  </d-container>
</template>

<script>
import Dashboard from './Dashboard';
import Welcome from './Welcome';

export default {
  name: 'home',
  components: {
    'dashboard': Dashboard,
    'welcome': Welcome
  },
  computed: {
    userIsCustomer () {
      return this.$store.getters.getUserType === 'customer';
    }
  }
}
</script>
